import { observable, computed } from 'mobx';
import _ from 'lodash';
import lqApi from '../api';

import { errorNotifiy } from '../core/error-helper';

export default class TicketStore {
  @observable barcode = null;
  @observable ticketGroups = [];
  @observable ticketGroupsCount = [];
  @observable tickets = [];
  @observable ticketInfo = {};
  @observable isOpenModal = false;
  @observable useTicketStateMessage = null;
  @observable allChecked = false;

  getShopSequence = async (barcode) => {
    const {
      available,
      done
    } = await lqApi.getShopGroups(barcode);

    const hasAvailableShopGroups = available.length > 0;
    const hasDoneShopGourps = done.length > 0;

    if(hasAvailableShopGroups) return available[0].shopSeq;
    if(hasDoneShopGourps) return done[0].shopSeq;
    return 0;
  }

  getTicketInfo = async (barcode, shopCode) => {
    const ticketInfo = await lqApi.getTicketInfo(barcode, shopCode);
    this.ticketInfo = ticketInfo;

    return ticketInfo;
  }

  setTicketGroups = async (barcode, shopCode) => {
    this.barcode = barcode || this.barcode;
    const ticketBarcode = this.barcode;
    const ticketGroups = await lqApi.getTicketGroups(ticketBarcode, shopCode);
    
    if (_.isEmpty(ticketGroups)) {
      errorNotifiy('티켓을 찾을 수 없습니다.');
      return;
    }
    
    this.ticketGroupsCount = [];
    
    const tickets = _.flatMap(ticketGroups, (ticketGroup) => {
      const tickets = ticketGroup.tickets;
      if (tickets.length > 0) this.ticketGroupsCount.push(tickets.length);
      return tickets;
    });
    
    _.forEach(tickets, (ticket) => {
      if (ticket.orderState === 'E' && ticket.ticketStatus.usable) {
        ticket.checked = true;
      } else {
        ticket.checked = false;
      }
    });
    
    this.ticketGroups = ticketGroups;
    this.tickets = tickets;
    
    this.allChecked = true;

    return true;
  }

  @computed get checkedTickets() {
    return _.filter(this.tickets, { checked: true });
  }

  toggleChecked = (pin) => {
    const ticket = _.find(this.tickets, { pin });
    ticket.checked = !ticket.checked;

    const notCheckedTickets = _.filter(this.tickets, (ticket) => {
      const {
        orderState,
        checked,
        ticketStatus: {
          usable
        }
      } = ticket;
      return orderState === 'E' && !checked && usable;
    });

    this.allChecked = notCheckedTickets.length > 0 ? false : true; 
  }

  AllTrueChange = (allChecked) => {
    this.allChecked = !allChecked;

    _.map(this.tickets, (ticket) => {
      const {
        ticketStatus: {
          usable: ticketUsable
        }
      } = ticket;
      if (ticket.orderState === 'E' && ticketUsable) ticket.checked = this.allChecked;
    });

    return this.tickets;
  }

  getAvailableTickets = () => {
    const tickets = this.tickets;
    const availableTickets = _.filter(tickets, (ticket) => {
      const {
        ticketStatus: {
          usable
        }
      } = ticket;
    
      return ticket.orderState === 'E' && usable;
    });

    const checkedTickets = _.filter(availableTickets, (ticket) => {
      const {
        checked
      } = ticket;

      return checked;
    });

    const allChecked = availableTickets.length === checkedTickets.length;

    return {
      availableTickets,
      checkedTickets,
      allChecked
    }
  }

  getBarcodeList = () => {
    return this.tickets;
  };

  usingTicketBarcode = async (pin) => {
    const usedPin = await lqApi.usingTicketBarcode(pin);
    return usedPin;
  }

  controlModal = (modalFlag) => {
    this.isOpenModal = modalFlag ? true : false;
  }

  usedControlModal = () => {
    this.isOpenModal = !this.isOpenModal;
    this.useTicketStateMessage = null;
  }

  setModalMessage = (useTicketsState) => {
    const successMessage = 
      `요청하신 ${useTicketsState.total}개의 티켓 중<br />
      ${useTicketsState.success}장이 사용 처리 되었습니다.`;

    const failMessage = 
      `요청하신 ${useTicketsState.total}개의 티켓 중<br />
      ${useTicketsState.fail}장이 사용 실패 하였습니다.<br />
      직원에게 문의해주세요.`;

    const stateMessage = useTicketsState.fail > 0 ? failMessage : successMessage ;

    const totalMessage = 
      `<br /><span class="txt-state">성공: ${useTicketsState.success} / 실패:  ${useTicketsState.fail}</span>`;
    
    this.useTicketStateMessage = stateMessage + totalMessage;
  }

  useTickets = async () => {
    const useGroupTickets = _.filter(this.tickets, { checked: true });

    const useTicketsState = {
      success: 0,
      fail: 0,
      total: useGroupTickets.length,
    };

    let totalTicket = useGroupTickets.length;

    _.each(useGroupTickets, async (ticket) => {
      const useTicketState = await this.usingTicketBarcode(ticket.pin);
      useTicketState.result = useTicketState.result.toUpperCase();

      if (useTicketState.result === 'SUCCESS') {
        useTicketsState.success++;

        ticket.orderState = 'A';
        ticket.orderStateNm = '사용완료';
      } else if (useTicketState.result === 'ERROR') {
        useTicketsState.fail++;

        ticket.orderState = 'F';
        ticket.orderStateNm = '사용실패';
      }
      ticket.checked = false;

      totalTicket--;

      if (totalTicket === 0) this.setModalMessage(useTicketsState);
    });
  };
}



// WEBPACK FOOTER //
// ./src/stores/TicketStore.js